import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { useId } from 'react';
import * as styles from './ai-gradient-sparkle-icon.css';

/**
 * Path data matches Pluma spritesheet symbol `pluma-icon-sparkle-filled`
 * (`sparkle-filled` in @customerio/pluma-icons).
 */
const SPARKLE_FILLED_PATH =
  'M15.987 9.36 23 12l-7.013 2.639L13.29 21.5l-2.699-6.861L3.58 12l7.012-2.64L13.29 2.5l2.697 6.86ZM5.189 19.068H3v-1.285h2.19V15.64h1.313v2.142h2.189v1.285h-2.19v2.142H5.19v-2.142Zm0-12.85H3V4.931h2.19V2.79h1.313v2.142h2.189v1.285h-2.19V8.36H5.19V6.217Z';

/** AI brand gradient (same stops as assistant footer “Ask Agent” sparkle). */
export function AiGradientSparkleIcon({ size = 40 }: { size?: number }) {
  const reactId = useId();
  const gradientId = `ai-gradient-sparkle-${reactId.replace(/:/g, '')}`;

  return (
    <svg
      className={styles.svgRoot}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradientId} x1="100%" y1="0%" x2="0%" y2="0%">
          <stop offset="0%" style={{ stopColor: themeVars.palette['orange-400'] }} />
          <stop offset="100%" style={{ stopColor: themeVars.palette['purple-500'] }} />
        </linearGradient>
      </defs>
      <path d={SPARKLE_FILLED_PATH} fill={`url(#${gradientId})`} />
    </svg>
  );
}
